// Who may approve or decline change-of-facility requests; mirrors Change_providersController::canDecide on the API,
// which has the final say: the agency account and its staff, except enrolment officers and view-only dashboard
// accounts (unless they are admins). Enrolment officers still prepare requests.
const ENROLMENT_TITLES = ["enrollment", "enrolment", "enrollment_bhcpf", "enrolment_bhcpf", "enrollment officer", "enrolment officer",
  "enrollment supervisor", "enrolment supervisor", "enrollment verification", "enrolment verification", "dashboard"];

export function canDecideChangeOfFacility(user) {
  if (!user || !["shis", "employee"].includes(user.type)) return false;
  if (user.type === "shis" || String(user.user_role) === "1") return true;
  return !ENROLMENT_TITLES.includes(String(user.job_title || "").trim().toLowerCase());
}
